import { render, staticRenderFns } from "./EditImport.vue?vue&type=template&id=20ff0067&scoped=true&"
import script from "./EditImport.vue?vue&type=script&lang=js&"
export * from "./EditImport.vue?vue&type=script&lang=js&"
import style0 from "./EditImport.vue?vue&type=style&index=0&id=20ff0067&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff0067",
  null
  
)

export default component.exports